// solanaUtils.ts
import { Connection, PublicKey } from "@solana/web3.js";
import { RPC_URLS } from "@/types/enums/WalletTypeEnum";
import { getAssociatedTokenAddress } from "@solana/spl-token";

/**
 * Retrieves the Token balance for a given Solana wallet address.
 * @param wallet - The wallet address as a string.
 * @param tokenMintAddress - The token contract address as a string.
 * @returns The balance of token as a number.
 */
export const getTokenBalanceByAddress = async (
  wallet: string,
  tokenMintAddress: string
): Promise<number> => {
  try {
    const connection = new Connection(RPC_URLS["solana"], "confirmed");
    // Derive the associated USDT token account
    const associatedTokenAccount = await getAssociatedTokenAddress(
      new PublicKey(tokenMintAddress),
      new PublicKey(wallet)
    );

    // ✅ Check if the token account exists
    const accountInfo = await connection.getAccountInfo(associatedTokenAccount);
    if (!accountInfo) {
      console.warn("Token account does not exist for this wallet.");
      return 0; // No USDT balance if the account doesn't exist
    }

    // ✅ Fetch balance if the account exists
    const balance = await connection.getTokenAccountBalance(
      associatedTokenAccount
    );
    return Number(balance.value.uiAmount || 0);
  } catch (error) {
    console.error("Error fetching SOL balance:", error);
    return 0; // Return 0 in case of an error
  }
};
